import React from "react";
import { cn } from "../../../lib/utils";

interface DashboardCardProps {
  icon: React.ReactNode;
  value: any;
  label: string;
  className?: string;
  variant?: "default" | "highlight";
  iconClassName?: string;
  width?: string;
}

const DashboardCard: React.FC<DashboardCardProps> = ({
  icon,
  value,
  label,
  iconClassName,
  variant = "default",
  width,
}) => {
  return (
    <div
      className={cn(
        "max-w-[248px] max-sm:w-[calc(50%-0.5rem)] max-sm:max-w-none h-full transition-all text-hColor",
        variant === "highlight"
          ? "bg-gradient-to-br from-gray-50 to-gray-100 border-gray-200"
          : "bg-white border-gray-200",
        width ?? "w-[186px]",
      )}
    >
      <div className="flex items-center justify-between w-full">
        <div className="flex items-center space-x-3 w-full">
          <div
            className={cn(
              `
            w-[54px] h-[54px] flex items-center justify-center p-2 rounded-lg bg-gray-100
          `,
              iconClassName,
            )}
          >
            {icon}
          </div>
          <div className="leading-tight">
            <p className="text-[20px] font-semibold text-hColor">
              {value.toLocaleString()}
            </p>
            <p className="text-[12px] text-[#676767] font-medium">{label}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DashboardCard;

// max-w-[248px] mx-auto w-full h-full rounded-xl p-4 border transition-all duration-200 hover:shadow-md text-hColor
